import React, { useState } from "react";
import styled from "styled-components";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { AvatarApi } from "services/avatar";
import { VALIDATIONS, INPUT_TYPES } from "utils/CommonConstants";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import TextInput from "sub_components/Common/BloxTextInput";

const PasswordChangeContainer = styled.div`
  .blox-text-input {
    width: 100%;
    margin-bottom: 8px;
    .active-field {
      input {
        -webkit-text-security: disc;
      }
    }
  }
  .password-change-email {
    margin-bottom: 0.5rem;
  }
  .error {
    color: #f58145;
  }
`;

export default function PasswordModal({
  show,
  closeModal,
  user,
  updateUserPassword,
  breakpoint,
  getSize,
}) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  function getHeader() {
    const avatarApi = new AvatarApi();
    return (
      <ModalHeader
        image={avatarApi.getGenericAvatar()}
        text={"Here you can change a shared users password."}
      />
    );
  }

  function handlePasswordChange(e) {
    setPassword(e.target.value);
    setError("");
  }

  function handleConfirmPasswordChange(e) {
    setConfirmPassword(e.target.value);
    if (!password) {
      setError("Password cannot be empty.");
    } else if (password?.length < 8) {
      setError("Password must be at least 8 characters.");
    } else if (password !== e.target.value) {
      setError("Passwords must match.");
    } else {
      setError("");
    }
  }

  function handleSubmit() {
    updateUserPassword(password);
  }

  return (
    <PortraitModalComponent
      closeModal={closeModal}
      show={show}
      header={getHeader()}
      subTitle={"Type the new password below."}
      title="Password Change"
      size={getSize(breakpoint)}
      breakpoint={breakpoint}
      customClassName={"role"}
    >
      <PasswordChangeContainer>
        <div className="password-change-email body10">
          Changing password for <span>{user?.userProfile?.emailAddress}</span>
        </div>
        <TextInput
          type={INPUT_TYPES.INPUT}
          label="Password"
          name="password"
          value={password}
          onChange={handlePasswordChange}
          validations={[VALIDATIONS.AT_LEAST_ONE_CHAR]}
          placeholder="Enter new password"
          active={true}
          hideCheckmark
          cypressId="change-password-password"
        />
        <TextInput
          type={INPUT_TYPES.INPUT}
          label="Confirm Password"
          name="confirmPassword"
          value={confirmPassword}
          validations={[VALIDATIONS.AT_LEAST_ONE_CHAR]}
          onChange={handleConfirmPasswordChange}
          placeholder="Confirm new password"
          active={true}
          hideCheckmark
          cypressId="change-password-confirm"
        />
        {error && <div className="error labels21">{error}</div>}
      </PasswordChangeContainer>
      <ModalFooter
        cypressId="footer"
        id="footer"
        buttonText1={"Confirm"}
        buttonText2="Back"
        buttonActive1={
          password && confirmPassword && password === confirmPassword
        }
        buttonActive2={true}
        module="account"
        buttonFunction1={handleSubmit}
        size={getSize(breakpoint)}
      />
    </PortraitModalComponent>
  );
}
